import {
  DashboardProjectsFieldDocument,
  type DashboardProjectsFieldQuery,
  type DashboardProjectsFieldQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_PROJECTS_FIELD_LOADER = async () => {
  const { data } = await client.query<
    DashboardProjectsFieldQuery,
    DashboardProjectsFieldQueryVariables
  >({
    query: DashboardProjectsFieldDocument,
    fetchPolicy: "network-only",
  });

  return data;
};
